import React from 'react';
import Auth from '../general/auth.js';
import moment from 'moment';

export default class InteractiveTests extends React.Component {

    constructor(props) {
        super(props);
        this.getIframePath = this.getIframePath.bind(this);
        this.checkAuth = this.checkAuth.bind(this);
        this.finishClick = this.finishClick.bind(this);
        this.updateAttempt = this.updateAttempt.bind(this);
        this.state = {
            authenticated: false,
            loaded: false,
            currentQuestion: 0,
            test: {},
            attempt: props.attempt,
            coursePath: ""
        }
    }
    componentDidMount() {
        this.checkAuth();
        document.addEventListener("keydown", this._handleEscKey, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleEscKey, false);
    }
    checkAuth() {
        new Auth().checkAuth(this.props.api, (result) => {
            this.setState({ authenticated: true, loaded: true });
            this.getIframePath();
        }, (err) => {
            console.dir(err);
        });
    }
    getIframePath() {

        this.setState({ loaded: false });
        this.props.api.send({
            controller: "Test",
            action: "GetInterPath",
            method: "post",
            body: JSON.stringify({ courseID: this.props.courseID }),
            success: (result) => {
                if (result.success) {
                    this.setState({ coursePath: result.path })
                }
                this.setState({ loaded: true });
            },
            error: (err) => {
                this.setState({ loaded: true });
                console.log(err);
            }
        })

    }
    updateAttempt(complete, callback) {
        var test = this.state.test;
        var curquestion = test.courseTestQuestions[this.state.currentQuestion];
        var myAnswers = curquestion.myAnswers;
        this.props.api.send({
            controller: "Test",
            action: "UpdateAnswer",
            method: "post",
            debug: true,
            body: JSON.stringify({
                testQuestionID: curquestion.testQuestionID,
                myAnswers: myAnswers,
                questionTime: curquestion.questionTime,
                complete: complete
            }),
            success: (result) => {
                callback();
                console.dir(result);
            },
            error: (err) => {
                console.dir(err);
            }
        })
    }
    finishClick() {
        this.updateAttempt(true, () => {
            this.props.getAttempt();
        });
    }
    renderMedia() {
        if (this.state.loaded) {
            if (this.state.attempt) {
                return (
                    <div>
                        <iframe className="interactiveCourseIframe" style={{height: '100vh'}} src={this.state.coursePath}
                            width='800px' height='800px' frameBorder='0' title="Course Content" alt="Interactive Media for Class">
                            <label>Cannot access the course. Please use another browser that suppoers IFrames.</label>
                        </iframe>
                    </div>
                )
            }
            else {
                return (
                    <div className="lmscoursearea">
                        <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Test</h1>
                        <h3>Course content is missing for this class.</h3>
                    </div>
                )
            }
        }
        else {
            return (
                <div className="lmscoursearea">
                    <h1>{this.state.attempt.courseInfo ? this.state.attempt.courseInfo.courseName : null} - Test</h1>
                    <h3>Course content is missing for this class.</h3>
                </div>
            )
        }
    }
    render() {
        return (
            <div>
                {this.state.loaded ? 
                    this.state.authenticated ?
                        <div>
                            {this.renderMedia()}
                        </div>
                    :
                        <div>
                            You are not authenticated or do not have access to this course.  <a href="/" className="bodylink">Log in here.</a>
                        </div>
                :
                    <div className="lmscenter">
                        <img src="/images/spinner.svg" alt="Loading..." className="spinnerbg" />
                    </div>
                }
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/course/interactivetests.js